export default function browserDetect(context = document) {
    const $body = $('body', context);
    const browserDetected = window.browser ? window.browser() : { name: 'unknown' };
    $body.addClass('browser-' + browserDetected.name);
}
